module.exports = __webpack_public_path__ + "static/media/yudagongzi.7afdb9d8.png";